import { ExternalLink, Users, CalendarDays, Sparkles, Phone } from "lucide-react";

const URL = "https://weihnachtsfeier.groemitzereiszeit.de/";
const IMG = "https://customer-assets-0z36b82j.emergentagent.net/job_85938a33-e9d2-4396-b30a-3a2ddc28d1a7/artifacts/776879feeca0f7fd_IMG_2690.webp";

const HIGHLIGHTS = [
  { icon: Users, title: "10–200 Personen", text: "für kleine und große Teams" },
  { icon: Sparkles, title: "Eisstock, Almhütte & Buffet", text: "alles aus einer Hand geplant" },
  { icon: CalendarDays, title: "27.11.2026 – 06.01.2027", text: "mitten im Grömitzer Winter" },
];

export const WeihnachtsfeierTeaser = () => (
  <section id="weihnachtsfeier" className="py-24 md:py-32 px-6 lg:px-12 bg-[#f6f1e7]" data-testid="weihnachtsfeier-section">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-5 relative">
        <div className="absolute -inset-3 rounded-[2rem] bg-emerald-900/10 rotate-[-2deg]" />
        <img
          src={IMG}
          alt="Gemütliche Weihnachtsfeier in der beleuchteten Almhütte"
          loading="lazy"
          className="relative w-full aspect-[4/5] object-cover rounded-[1.75rem] shadow-2xl"
          data-testid="weihnachtsfeier-image"
        />
      </div>

      <div className="lg:col-span-7">
        <span className="text-sm font-medium tracking-widest uppercase text-emerald-800 mb-4 block">
          Weihnachtsfeiern 2026 · Grömitz
        </span>
        <h2
          className="text-4xl md:text-5xl font-medium tracking-tight text-slate-900 mb-6"
          style={{ fontFamily: 'Playfair Display' }}
          data-testid="weihnachtsfeier-title"
        >
          Weihnachtsfeier in der Almhütte
        </h2>
        <p className="text-lg text-slate-600 max-w-2xl mb-10">
          Raus aus dem üblichen Restaurantabend: Startet mit einer lockeren Eisstock-Challenge und feiert danach
          gemeinsam in unserer gemütlichen Almhütte – mit Winterbuffet und Getränken, ganz nach euren Wünschen.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
          {HIGHLIGHTS.map(({ icon: Icon, title, text }) => (
            <div key={title} className="rounded-2xl bg-white/80 border border-emerald-900/10 p-5 transition-transform duration-300 hover:-translate-y-1">
              <Icon className="w-6 h-6 text-emerald-700 mb-3" />
              <p className="font-semibold text-slate-900">{title}</p>
              <p className="text-sm text-slate-500">{text}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-4">
          <a
            href={URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 h-12 px-8 rounded-full bg-emerald-800 hover:bg-emerald-900 text-white font-semibold shadow-lg shadow-emerald-900/20 transition-colors"
            data-testid="weihnachtsfeier-anfragen-btn"
          >
            Jetzt anfragen
            <ExternalLink className="w-4 h-4" />
          </a>
          <a
            href="tel:+4915561642249"
            className="inline-flex items-center gap-2 text-slate-700 hover:text-emerald-800 font-medium transition-colors"
            data-testid="weihnachtsfeier-phone-link"
          >
            <Phone className="w-4 h-4" />
            0155 61642249
          </a>
        </div>
      </div>
    </div>
  </section>
);
